// schedule strings (en). Source language for the SCHEDULE / RECIPIENTS flow.
const schedule = {
	schedule: {
		// Shared
		cancel: 'Cancel',
		next: 'Next',
		continue: 'Continue',
		loading: 'Loading ...',
		edit: 'Edit',
		yes: 'Yes',
		no: 'No',
		add: 'Add',
		update: 'Update',
		errorTitle: 'Error',
		oops: 'Oops!',
		searchRecipients: 'Search recipients',

		// Header
		editCard: 'Edit card',

		// Progress bar / steps
		progress: 'Progress',
		step1: 'Step 1',
		step2: 'Step 2',
		step3: 'Step 3',
		letsSendYourCard: 'Let’s send your card',
		stepAddRecipients: 'Add some recipients',
		stepConnectEmail: 'Connect your email account',
		stepCustomizeSubject: 'Customize the subject line',

		// Sender detail / email account
		selectEmailAccount: 'Select an Email account',
		selectPreferredEmail: 'Select your preferred email account to send cards from.',
		noEmailAccounts: 'No email accounts to show',
		addNewEmailAccount: '+ Add new email account',
		confirmEmailAccount: 'Confirm email account',
		sendUsingDefaultTitle: 'Send using our default mailing system',
		sendViaDefault: 'Send via default email address',
		connectPersonalEmail: 'Please connect your personal email address',
		orSendDefaultAccount: 'or send using our default account.',
		selectCustomEmailError:
			'Please select a custom email account to schedule the card or select the option to send using our default email.',
		planNoCustomEmail: 'Your plan does not allow adding custom email accounts. Please updgrade your plan',
		emailAccountsLimitReached: 'Your email accounts limit has reached. Please updgrade your plan to add more email accounts',

		// Add recipient intro / empty state
		addRecipientsIntro: 'You can add recipients individually or import a contact list by uploading a Bulk CSV',
		noRecipientsYet: 'You have no recipients yet.',
		addNamesEmails: 'Add the Names and Email addresses of your card Recipients.',
		uploadCsv: 'Upload CSV',
		addRecipient: 'Add recipient',

		// Contact list
		prepareContactList: "Let's prepare your contact list",
		fileUploadedPrepare: "Your file is successfully uploaded. Now let's prepare it for personalization of the cards",
		contactListTitle: 'Contact list title',
		whatIsContactList: 'What is a contact list?',
		contactListDescription:
			'Contact list is a contact book which you can use anytime you want, to send personalized and bulk cards',
		noCsvSelected: 'no csv file selected',

		// Merge tags
		selectMergeTags: 'SELECT MERGE TAGS',
		whatIsMergeTag: 'What is a merge tag?',
		mergeTagDescription:
			'Merge tags are personalized tags mapped with your bulk data to personalize documents, graphics etc.',
		enterTagName: 'Enter tag name',
		addNewMergeTagBtn: 'Add new merge tag',
		duplicateMergeTag: 'Cannot add merge tag with the same name.',

		// Upload CSV modal
		uploadCsvHere: 'Upload your CSV file here',
		uploadCsvDescription:
			'Once you upload your CSV, %{app} will map your data with the available merge tags along with custom tags for you to personalize each card and send cards to as many contacts you want',
		downloadCsvTemplate: 'Download CSV template',
		csvColumnsLabel: 'Columns:',
		csvExtraColumns: '. Extra columns become merge tags.',
		csvExampleLabel: 'Example:',
		changeFile: 'Change file',
		csvFileLabel: 'CSV File',
		clickToUpload: 'Click to upload your csv file',

		// Recipients table / list
		recipientsHeader: 'RECIPIENTS',
		missingFields: 'Missing fields',
		errorsCount: '%{count} error(s)',
		invalidRecipientEmails: 'Invalid recipient emails',
		invalidEmailsCount: '%{count} invalid email(s)',
		fromLabel: 'From',
		listSuffix: 'list',
		addNewRecipient: 'Add new recipient',
		copyCardUrl: 'Copy card URL',
		scheduleForLater: 'Schedule for later',
		saveAndNext: 'Save and Next',
		selectAll: 'Select all',
		unnamed: 'Un-named',
		noRecipientsFound: 'No recipients found.',

		// Toasts / swal (recipients)
		updatedRecipientSuccess: 'Updated recipient successfully',
		addedRecipientSuccess: 'Added recipient successfully',
		decrementLimitByCount: 'This action will decrement your recipient limit by %{count}!',
		decrementLimit: 'This action will decrement your recipient limit!',
		linkCopied: 'Link copied successfully',

		// Copy card URL modal
		getCardUrls: 'Get card URLs',
		copyUrlDescription:
			'You can copy URL of recipients and send them directly via any medium e.g. messenger, whatsapp etc.',
		downloadAsCsv: 'Download as CSV',
		copyUrl: 'Copy URL',
		noRecipientsToCopy: 'No recipients to copy.',

		// Schedule modals
		scheduleCard: 'Schedule card',
		addDateTimeDescription:
			'Let’s add the date and time you want your contacts to receive the card. You can also change the schedule manually for recipients.',
		selectDateTime: 'Select date and time',
		missingData: 'Missing data',
		missingDataDescription:
			'You have some missing data in the columns which might cause an issue in sending the cards.',
		updateData: 'Update data',
		skipContinue: 'Skip & continue',

		// Add recipient modal / form
		recipientInfo: 'Recipient info',
		updateRecipientInfoDesc: 'Update your recipients information, so they will receive card properly.',
		addNameEmailDesc: 'Add name and email address of recipient',
		basicInfo: 'BASIC INFO',
		nameLabel: 'name',
		emailLabel: 'email',
		nameOfRecipient: 'Name of the recipient',
		mergeTagsLabel: 'MERGE TAGS',
		recurring: 'Recurring',
		yearly: 'Yearly',
		monthly: 'Monthly',
		weekly: 'Weekly',
		daily: 'Daily',

		// Customize subject / preview
		whoIsCardFrom: 'Who is this card from',
		recipientsLeft: 'You have %{count} recipient(s) left',
		unlimitedRecipients: 'You have unlimited email recipients',
		customizeSubjectEmail: 'Customize the subject of the email.',
		customizeHeader: 'Customize the Card Preview Header',
		customizeFooter: 'Customize the Card Preview Footer',
		addCta: 'Add CTA in Preview Card',
		toggleConfetti: 'Toggle confetti',
		howCardLooksEmail: 'How card looks in Email?',
		howCardLooksViewScreen: 'How card to looks in View card screen?',
		enterSenderName: "Enter sender's name",
		subjectLinePlaceholder: 'Hey %{tag}, %{name} created a digital card for you.',
		subjectLineFromPlaceholder: 'Hey %{tag}, from %{name} created a digital card for you.',
		cardPreviewHeaderPlaceholder: 'Card Preview Header',
		cardPreviewFooterPlaceholder: 'Card Preview Footer',
		unsubscribeTextPlaceholder: 'Unsubscribe link text (optional)',
		ctaTextLabel: 'Text',
		ctaPlaceholder: 'Click here',
		subjectLineHint:
			'Add a preferred sender name and Subject line. You can also add Merge tags in subject line as well',

		// Scheduled recipients table / fallback date
		cardsReadyToSchedule: 'Card(s) ready to schedule',
		manualScheduleHint: 'You can manually change the schedule for each card if you’re willing to do that',
		sendDateFallbackLabel: 'Send date for recipients without a date in the CSV',
		fallbackHintCsv:
			'Recipients with a valid schedule_date in your CSV keep their own date. This fallback applies to everyone else.',
		fallbackHintNoCsv: 'Applies this date to every recipient. Override individual rows in the table below.',
		pickFallbackDate: 'Pick a fallback date',
		applyScheduleDates: 'Apply schedule dates',
		sendCard: 'Send card',
		scheduledAt: 'Scheduled At',
		now: 'Now',
		noSelectedRecipients: 'No selected recipients found.',

		// Email preview
		emailFooterDefault: 'Your inbox just got a special delivery. View your card online.',
		viewCard: 'View card',
		unsubscribe: 'unsubscribe',

		// Toasts / swal (schedule / apply)
		cardScheduledSuccess: 'Card Scheduled!',
		saveCardProblem: 'There was a problem while saving your card. Please try again.',
		pickFallbackOrCsv: 'Pick a fallback send date or upload a CSV with a schedule_date column.',
		scheduleAppliedCount: 'Schedule applied to %{count} recipient(s).',
		applyScheduleFailed: 'Failed to apply schedule dates. Please try again.',
	} as Record<string, string>,
};
export default schedule;
